export default __webpack_public_path__ + "static/media/classtrack_UF.17e03dec.png";